import { Dialog } from 'components/Dialog';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  doHideSignatureDialog,
  eventTypeSignatureTaken,
} from 'store/app/actions';
import { selectSignature } from 'store/app/selectors';
import { SignaturePad } from '../components/Signature/SignaturePad';

export const DialogSignature: React.FC = () => {
  const dispatch = useDispatch();
  const signature = useSelector(selectSignature);

  const [userSignature, setUserSignature] = React.useState<string>('');

  if (!signature) {
    return null;
  }

  const handleDismiss = () => {
    setUserSignature('');
    dispatch(doHideSignatureDialog());
  };

  const handleConfirm = () => {
    dispatch(
      eventTypeSignatureTaken({
        eventKey: signature.eventKey,
        signature: userSignature,
      }),
    );
    setUserSignature('');
    dispatch(doHideSignatureDialog());
  };

  const buttons = [
    {
      text: 'Cancel',
      onPress: handleDismiss,
    },
    {
      text: 'Done',
      onPress: handleConfirm,
      disabled: !userSignature,
    },
  ];

  return (
    <Dialog
      buttons={buttons}
      onDismiss={handleDismiss}
      scrollEnabled={false}
      contentStyle={{
        padding: 0,
      }}
      dismissWithOverlay={false}
    >
      <SignaturePad onChange={setUserSignature} />
    </Dialog>
  );
};
